var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-x';
                    var viewUrl = 'sprite.svg#view-icon-x';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-x#icon-x';
                            viewUrl = 'sprite.svg?icon-x#view-icon-x';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 37 37',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };